// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getAttachableCharges } from '@/billing/api/get-attachable-charges';
import { useQuery } from '@tanstack/react-query';

export function useAttachableCharges(invoiceKey: string, enabled: boolean) {
  return useQuery({
    queryKey: ['invoice', invoiceKey, 'attachable-charges'],
    queryFn: () => getAttachableCharges(invoiceKey),
    enabled,
  });
}
